<script setup>
import { nextTick, onMounted, ref, watch } from 'vue';

const props = defineProps([
  'bindId',
  'disabled',
  'placeholder',
  'froalaValue',
  'iconBtns',
  'minHeight',
  'maxHeight',
]);
const emit = defineEmits(['update']);
const editor = ref(null);

const editorValue = ref(props.froalaValue);
watch(
  () => props.froalaValue,
  (val) => {
    editorValue.value = val ? val : '';
  },
  {
    deep: true,
  },
);
watch(editorValue, (v) => {
  emit('update', v);
});

const editorConfig = {
  apiKey: import.meta.env.VITE_FROALA_API_KEY,
  key: import.meta.env.VITE_FROALA_API_KEY,
  placeholderText: props?.placeholder ?? '',
  charCounterCount: false,
  toolbarButtons: props.iconBtns ?? [
    'bold',
    'italic',
    'underline',
    'strikeThrough',
    'textColor',
    'backgroundColor',
    'emoticons',
    '|',
    'paragraphFormat',
    'align',
    'formatOL',
    'formatUL',
    'indent',
    'outdent',
    '|',
    'insertLink',
    'insertImage',
    'insertFile',
    'insertVideo',
    'undo',
    'redo',
  ],
  toolbarSticky: true,
  heightMin: props?.minHeight ?? 200,
  heightMax: props?.maxHeight ?? null,
  events: {
    initialized() {
      if (props.disabled) {
        this.edit.off();
      }
    },
  },
};

watch(
  () => props.disabled,
  (isDisabled) => {
    if (!isDisabled) {
      editor.value?.data?._editor?.edit?.on();
    } else {
      editor.value?.data?._editor?.edit?.off();
    }
  },
);

const deferrInit = ref(true);

onMounted(() => {
  nextTick(() => {
    deferrInit.value = false;
  });
});
</script>

<template>
  <froala
    :style="{ minHeight: minHeight }"
    v-if="!deferrInit"
    :id="bindId"
    ref="editor"
    :config="editorConfig"
    v-model:value="editorValue"
  ></froala>
</template>
